/**
 * init slider for product detail page
 */
class RatingsAndReviews {
    constructor() {
        RatingsAndReviews.initFAQ();
    }

    static initFAQ() {
        console.info('RatingsAndReviews.initFAQ()');

        $('.js-accordian-toggle').on('click', (e) => {
            $(e.currentTarget).parent().toggleClass('active');
        });
    }
}

function initializePage() {
    const ratingsAndReviews = new RatingsAndReviews();
}

initializePage();